import disclosureSlider from "./slider"
import Lightbox from '../../../../resources/js/utils/_lightbox'
import disclosure from './disclosure'

document.addEventListener('DOMContentLoaded', () => {
  disclosureSlider()
  disclosure()
  new Lightbox(document.querySelectorAll('.mtt-slider-with-disclosure .mtt-slider-with-disclosure__disclosure-item-image-wrapper'))
})

